<style lang="scss">
  @import '../resources/scss/digitalgrow_details.scss';
</style>

<script lang="ts">
  import type DetailsSection from '../api/rest/directus-cms/digitalgrow/models/DetailsSections'

  export let section: DetailsSection
</script>

{#if section}
  <section id="digital-platform">
    <div class="container-fluid bg-primary-e text-white py-section">
      <div class="container-xxl">
        <div class="row">
          <div class="col-12">
            <h1 class="pb-3">{section.title}</h1>
            <div class="mt-4 h4">
              {@html section.text}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
{/if}
